import React, {useEffect, useState} from 'react';
import {Navigate, useNavigate, useParams} from 'react-router-dom';
import {resolveRoomSlug, RoomSlugResolution} from '../../../service/room.service';
import RoomSlugResolutionContext from '../../../context/RoomSlugResolutionContext';
import RoomWrapper from './RoomWrapper';

function RoomSlugWrapper(): JSX.Element {
    const {slug} = useParams<{slug: string}>();
    const navigate = useNavigate();
    const [resolution, setResolution] = useState<RoomSlugResolution | null>(null);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        if (!slug) {
            navigate('/', {replace: true});
            return () => {
                // noop
            };
        }

        let cancelled = false;

        resolveRoomSlug(slug).then((result) => {
            if (cancelled) return;

            if (!result) {
                setFailed(true);
                return;
            }

            setResolution(result);
        });

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slug]);

    if (failed) {
        return <Navigate replace to="/" />;
    }

    if (!resolution) {
        return (
            <div className="c-spinner">
                <div className="c-spinner__main">
                    <div />
                    <div />
                    <div />
                    <div />
                </div>
            </div>
        );
    }

    return (
        <RoomSlugResolutionContext.Provider value={resolution}>
            <RoomWrapper />
        </RoomSlugResolutionContext.Provider>
    );
}

export default RoomSlugWrapper;
